export default __webpack_public_path__ + "static/Video3loop-8935f3900ba1a88617dd39d7e1c27919.mp4";